"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.defaultComboBoxImageButtonElement = exports.DefaultBackgroundElement = exports.defaultDropdownSelectElement = exports.defaultDropdownOptionsElement = exports.defaultOptionImageElementRow = exports.defaultOptionImageElement = void 0;
exports.createImageDropdownSelector = createImageDropdownSelector;
const react_1 = __importDefault(require("react"));
const combo_box_image_element_row_1 = require("./combo-box-image-element-row");
const combo_box_image_button_element_1 = require("./combo-box-image-button-element");
const defaultOptionImageElement = (props) => (react_1.default.createElement("img", Object.assign({}, props, { style: {
        maxWidth: "2em",
        maxHeight: "2em"
    } })));
exports.defaultOptionImageElement = defaultOptionImageElement;
// export const defaultOptionImageElementRow = styled(
//   ComboBoxImageOptionElementRow
// )`
//   color: rgb(131, 131, 131);
//   min-height: 18px;
//   align-self: center;
//   border: 0px none rgb(131, 131, 131);
//   font: normal normal 300 normal 15px / 30px Helvetica, Arial, sans-serif;
//   outline: rgb(131, 131, 131) none 0px;
//   padding: 0.2em 0.5em;
//   cursor: default;
//   &:hover {
//     background-color: blue;
//     color: white;
//   }
//   ${props => (props.isItemValid === false ? "color: red;" : "")};
// `;
const defaultOptionImageElementRow = (props) => (react_1.default.createElement(combo_box_image_element_row_1.ComboBoxImageOptionElementRow, Object.assign({}, props, { style: {
        color: props.isItemValid === false ? "color: red;" : "rgb(131, 131, 131)",
        minHeight: "18px",
        alignSelf: "center",
        border: "0px none rgb(131, 131, 131)",
        font: "normal normal 300 normal 15px / 30px Helvetica, Arial, sans-serif",
        outline: "rgb(131, 131, 131) none 0px",
        padding: "0.2em 0.5em",
        cursor: "default"
        // &:hover {
        //   background-color: blue;
        //   color: white;
        // }
    } })));
exports.defaultOptionImageElementRow = defaultOptionImageElementRow;
const defaultDropdownOptionsElement = (props) => (react_1.default.createElement("div", Object.assign({}, props, { style: {
        position: "absolute",
        display: "block",
        background: "white",
        border: "1px solid #bbb",
        listStyle: "none",
        margin: 0,
        padding: 0,
        zIndex: 100
    } })));
exports.defaultDropdownOptionsElement = defaultDropdownOptionsElement;
// export const defaultDropdownSelectElement = styled.div`
//   user-select: none;
//   img {
//     vertical-align: middle;
//   }
// `;
const defaultDropdownSelectElement = (props) => (react_1.default.createElement("div", Object.assign({}, props, { style: {
        userSelect: "none"
        // img {
        //   vertical-align: middle;
        // }
    } })));
exports.defaultDropdownSelectElement = defaultDropdownSelectElement;
const DefaultBackgroundElement = (props) => (react_1.default.createElement("div", Object.assign({}, props, { style: {
        position: "absolute",
        top: 0,
        bottom: 0,
        left: 0,
        right: 0
    } })));
exports.DefaultBackgroundElement = DefaultBackgroundElement;
const defaultComboBoxImageButtonElement = (props) => (react_1.default.createElement(combo_box_image_button_element_1.ComboBoxImageElement, Object.assign({}, props, { style: Object.assign({ width: "162px", alignItems: "center", background: "white", color: "black", height: "30px", whiteSpace: "nowrap", border: "1px solid #b4b4b4", borderRadius: "3px", font: "normal normal 300 normal 15px / 30px Helvetica, Arial, sans-serif", outline: "rgb(131, 131, 131) none 0px", padding: "1px 5px 0px 14px", textAlign: "right" }, buttonElementStyles(props)) })));
exports.defaultComboBoxImageButtonElement = defaultComboBoxImageButtonElement;
function createImageDropdownSelector({ OptionImage = exports.defaultOptionImageElement, OptionImageElementRow = exports.defaultOptionImageElementRow, DropdownOptionsElement = exports.defaultDropdownOptionsElement, DropdownSelectElement = exports.defaultDropdownSelectElement, ComboBoxImageButtonElement = exports.defaultComboBoxImageButtonElement }) {
    // eslint-disable-next-line functional/no-class
    return class extends react_1.default.Component {
        constructor(props) {
            super(props);
            this.state = {
                isOpen: false
            };
        }
        render() {
            const { value, onChange, options, isSelectedItemValid, locked } = this.props;
            const selected = options.find(o => o.value === value);
            const background = this.state.isOpen ? (react_1.default.createElement(exports.DefaultBackgroundElement, { onClick: () => this.setState({ isOpen: false }) })) : undefined;
            const optionsList = this.state.isOpen ? (react_1.default.createElement(DropdownOptionsElement, null, options.map(o => {
                return (react_1.default.createElement(OptionImageElementRow, { key: o.value, isItemValid: o.isItemValid, title: o.tooltip, onClick: () => {
                        onChange(o.value);
                        this.setState({ isOpen: false });
                    } }, this._renderItem(o)));
            }))) : undefined;
            return (react_1.default.createElement(DropdownSelectElement, null,
                background,
                react_1.default.createElement(ComboBoxImageButtonElement, { isSelectedItemValid: isSelectedItemValid, locked: locked, title: selected !== undefined ? selected.tooltip : undefined, onClick: () => this.setState({ isOpen: !this.state.isOpen }) },
                    this._renderItem(selected),
                    react_1.default.createElement("i", { className: "fa fa-caret-down" })),
                optionsList));
        }
        // eslint-disable-next-line class-methods-use-this
        _renderItem(item) {
            if (item === undefined) {
                return react_1.default.createElement("span", null);
            }
            const image = item.imageUrl ? (react_1.default.createElement(OptionImage, { src: item.imageUrl })) : (react_1.default.createElement("span", null));
            return (react_1.default.createElement("span", null,
                image,
                " " + item.label + " "));
        }
    };
}
function buttonElementStyles(props) {
    if (props.isSelectedItemValid === false && props.locked) {
        return {
            background: "lightgray",
            color: "red",
            border: "none"
        };
    }
    else if (props.isSelectedItemValid === false) {
        return { color: "red" };
    }
    else if (props.locked) {
        return {
            background: "lightgray",
            color: "darkgray",
            border: "none"
        };
    }
    return {};
}
//# sourceMappingURL=image-dropdown-selector.js.map